import Immutable from "immutable";
import recordMerger from "services/record-merger";

export const CSAT_MESSAGE_TYPE = "csat";

export class LogRecord extends Immutable.Record({
  id: null,
  by: null,
  clientId: null,
  clientToken: null,
  conversationId: null,
  created: null,
  message: null,
  responseId: null,
  review: null,
  timeBucket: null,
  source: null,
  to: null,
  agentInfo: null
}) {}

let newLog;

export const logs = (state = Immutable.List([]), action) => {
  switch (action.type) {
    case "GET_LOGS_SUCCESS": {
      let nextState = state;

      action.response.data.log.forEach((item, index) => {
        const record = recordMerger(item, new LogRecord());

        if (record.message.agentInfo) {
          record.agentInfo = Immutable.fromJS(record.message.agentInfo);
        }

        newLog = new LogRecord(record);

        // not a great way of fixing the duplication bug. Will need to find root cause
        if (nextState.getIn([nextState.size - 1 - index, "id"]) !== newLog.id) {
          nextState = nextState.unshift(newLog);
        }
      });

      return nextState;
    }

    case "ADD_LOG_TO_CONVERSATION_SUCCESS": {
      const record = recordMerger(action.log, new LogRecord());

      if (record.message.agentInfo) {
        record.agentInfo = Immutable.fromJS(record.message.agentInfo);
      }

      newLog = new LogRecord(record);

      return state.push(newLog).sortBy(nlog => nlog.get("created"));
    }

    case "CLEAR_LOGS": {
      return state.clear();
    }

    default:
      return state;
  }
};
